import { Image, ImageWrapper, OverlayWrapper, Tag, TagWrapper } from './style';
import PropTypes from 'prop-types';
import React, { isValidElement } from 'react';

const defaultProps = {
  customStyle: {
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(34, 34, 34, 0) 100%)`
  }
};

const ImageTag = ({ tag }) => {
  if (isValidElement(tag)) {
    return <>{tag}</>;
  }

  if (tag) {
    return (
      <TagWrapper>
        <Tag>{tag}</Tag>
      </TagWrapper>
    );
  }

  return null;
};

const CardImage = ({
  src,
  ratio,
  tag,
  overlayContent,
  customStyle: propsCustomStyle
}) => {
  const customStyle = { ...defaultProps.customStyle, ...propsCustomStyle };

  return (
    <ImageWrapper ratio={ratio}>
      <Image src={src.url} alt={src.alt} />
      <ImageTag tag={tag} />
      {overlayContent && (
        <OverlayWrapper customStyle={customStyle}>
          {overlayContent}
        </OverlayWrapper>
      )}
    </ImageWrapper>
  );
};

CardImage.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * overlay content custom style
   */
  customStyle: PropTypes.shape({
    /**
     * overlay content background
     * @default "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(34, 34, 34, 0) 100%)"
     */
    background: PropTypes.string
  }),
  /**
   * overlay content on image
   */
  overlayContent: PropTypes.node,
  /**
   * Image ratio
   */
  ratio: PropTypes.oneOf(['1:1', '16:9', '3:2']),
  /**
   * Image source and alternative text
   */
  src: PropTypes.shape({
    alt: PropTypes.string,
    url: PropTypes.string.isRequired
  }).isRequired,
  /**
   * Image tag
   */
  tag: PropTypes.string | PropTypes.node
};

export default CardImage;
